export default "__VITE_ASSET__d0c89a1f__"